/**
 * Breakpoints shared by JS (matchMedia) and referenced by CSS @media.
 * Mobile: max-width 767px → CSS tablet/small-desktop rules use min-width 768px.
 * Compact: layout/CTA compact mode up to 1180px (aligns with index.css tablet band).
 *
 * Manual viewport pass (smoke-test when changing layout):
 * - Widths: 320, 375, 390, 428; tablet 768, 820, 1024; desktop 1280+
 * - Heights: tall phone, short (SE-style), landscape phone, shallow desktop window
 * - Stages: hero → CTA → social (scroll end, FAB clearance) → Spotify → bookings → footer
 */
export const BREAKPOINT_MOBILE_MAX_PX = 767;
export const BREAKPOINT_COMPACT_MAX_PX = 1180;

/** Matches phone / narrow layouts; pair with CSS `(max-width: 767px)`. */
export const MEDIA_MOBILE = `(max-width: ${BREAKPOINT_MOBILE_MAX_PX}px)`;

/** Matches tablet + small laptop where compact CTA and tighter gutters apply. */
export const MEDIA_COMPACT = `(max-width: ${BREAKPOINT_COMPACT_MAX_PX}px)`;
